// Stat-type token for the reader-configured custom table (players only).
export const CUSTOM_STAT_TYPE = 'custom';

export const statOptions = [
  { value: 'attack', label: 'Key Stats' },
  { value: 'shooting', label: 'Goal Threat' },
  { value: 'creativity', label: 'Creativity' },
  { value: 'passing', label: 'Passing' },
  { value: 'involvement', label: 'Involvement' },
  { value: 'setpieces', label: 'Set Pieces' },
  { value: 'defending', label: 'Defending' },
  { value: 'defensive', label: 'Defensive' },
  { value: 'fpl', label: 'FPL' },
  { value: CUSTOM_STAT_TYPE, label: 'Custom' }
];

export const typeOptions = [
  { value: 'players', label: 'Players' },
  { value: 'teams', label: 'Teams' }
];
